<template>
    <div class="formset__header" :class="{'formset__header--errors': this.errors}">
        <span><i v-if="errors" class="fa fa-warning"></i> {{ label }}</span>
        <div class="formset__header__buttons">
            <el-button @click.stop="changeOrder(items, index, 1)"
                       v-if="index !== items.length - 1"
                       size="small"
                       title="Przesuń w dół">
                <i class="fa fa-arrow-down"></i>
            </el-button>
            <el-button @click.stop="changeOrder(items, index, -1)"
                       :style="{opacity: index !== 0 ? 1 : 0}"
                       size="small"
                       title="Przesuń do góry">
                <i class="fa fa-arrow-up"></i>
            </el-button>
            <el-button @click.stop="removeItemFromFormset(items, item)"
                       type="danger"
                       size="small"
                       title="Usuń element">
                <i class="fa fa-remove"></i>
            </el-button>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['index', 'items', 'label', 'errors'],
        computed: {
            item () {
                return this.items[this.index]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FormsetHeader.vue?5eca83f8